module.exports = __webpack_public_path__ + "img/login-vector-mobile.945f9752.webp";